/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Type__Regular7Inputs */

const en_subscription_type__regular7 = /** @type {(inputs: Subscription_Type__Regular7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Subscription_Type__Regular7Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const subscription_type__regular7 = /** @type {((inputs?: Subscription_Type__Regular7Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Type__Regular7Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_subscription_type__regular7(inputs)
});
export { subscription_type__regular7 as "subscription_type__REGULAR" }